import type { QuestionModule } from "../contracts";
import {
  gridThisOrThatCore,
  type GridThisOrThatDefinition,
  type GridThisOrThatDraft,
  type GridThisOrThatEvent,
  type GridThisOrThatRaw,
  type GridThisOrThatResponse,
} from "./core";
import { GridThisOrThatView } from "./views";

export const gridThisOrThatModule: QuestionModule<
  GridThisOrThatRaw,
  GridThisOrThatDefinition,
  GridThisOrThatDraft,
  GridThisOrThatEvent,
  GridThisOrThatResponse
> = {
  type: "grid_this_or_that",
  galleryFeatures: [
    "visual-groups",
    "baseline",
    "pairs",
    "images",
    "option-images",
    "restored",
  ],
  core: gridThisOrThatCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Pairs",
      component: GridThisOrThatView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "default" },
  controls: (_definition, _draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
  }),
};
